var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"end-page"},[_c('square',{attrs:{"src":"https://img.xinshu.me/upload/fab544122fa72fe9b4b0746cf9f2a99b!800","height":"a5"}},[_c('div',{staticClass:"barcode"},[_c('img',{attrs:{"src":_vm.barcode,"alt":""}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }